<template>
    <section>
      <div class="d-flex justify-content-center hv-100">
        <div class="container-fluid hv-100">
        <div class="row hv-100 mobile-100">
          <!-- Form -->
          <div class="d-flex flex-row align-items-center col-sm-12 col-lg-7 bg-white mobile-100">
            <div class="col-md-6 offset-md-3">
              <h3 class="text-lg-left my-1"><span class="font-weight-bold">{{ $t('lang.label.needanewpassword') }}</span></h3>
              <p class="text-left">{{ $t('lang.label.pleaseprovideyouremailaddressandwellsendyou') }}</p>
              <div v-if="alert.message" :class="`login-alert alert ${alert.type}`">{{alert.message}}</div>
              <form @submit.prevent="handleSubmit" class="login-form">
                <div class="input-wrapper">
                  <label for="user">Email</label>
                  <input
                    type="text"
                    v-model="email"
                    name="email"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && !email }"
                  />
                  <div v-show="submitted && !email" class="invalid-feedback">{{ $t('lang.label.required') }}</div>
                </div>

                <div class="row">
                  <div class="col-12 mt-3">
                    <button class="btn btn-primary btn-block" :disabled="wasSent">{{ $t('lang.button.send_password') }}</button>
                  </div>
                  <div class="col-12 text-center mt-4 pt-3">
                    <router-link to="/login" class="nav-link">
                      <span class="icon-dashboard d-md-none"></span>
                      <span >{{ $t('lang.button.login') }}</span>
                    </router-link>
                  </div>
                </div>

              </form>
            </div>
          </div>
          <!-- Panel right -->
          <Features />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Features from "@/components/AccountCreation/Steps/Features.vue";
export default {
  components: {
    Features
  },
  data() {
    return {
      email: "",
      submitted: false
    };
  },
  computed: {
    wasSent() {
      return this.submitted;
    },
    alert() {
      return this.$store.state.alert;
    }
  },
  created() {
    if(this.$route.query.email !== undefined){
      this.email = this.$route.query.email;
    }

  },
  methods: {
    handleSubmit(e) {
      this.submitted = true;
      const { email } = this;
      const { dispatch } = this.$store;
      if (email) {
        dispatch("authentication/requestNewPassword", { email });
      }
    },
  },
};
</script>
<style scoped>
  @media only screen and (max-width: 600px) {
  .mobile-100 {height:100vh}
  }
</style>
